import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.page.html',
  styleUrls: []
})
export class NewUserPage implements OnInit {

  roles: any = [];
  genders: any = this.uService.genders;
  userStatuses: any = this.uService.userStatuses;
  id: string;
  attrHide: boolean = false;
  filterTerm: string = '';
  filterTerm2: string = '';

  newUserForm: FormGroup = new FormGroup({
    first_name: new FormControl('', Validators.required),
    last_name: new FormControl('', Validators.required),
    // username: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    cellphone: new FormControl(''),
    role: new FormControl([], Validators.required),
    // gender: new FormControl('', Validators.required),
    // ci: new FormControl('', Validators.required),
    // status: new FormControl('', Validators.required),
    // password: new FormControl('', Validators.required),
    // password_check: new FormControl('', Validators.required),
  });

  // branchForm: FormGroup = new FormGroup({
  //   branch: new FormControl('')
  // })

  setFocus(id: any) {
    var input  = document.getElementById(id);
    if(input !== null){
      input.focus();
    }
  }

  createEditUser(){
    if(this.newUserForm.valid){
      var body = this.newUserForm.value;
      body.role = [body.role]

      if(this.id != undefined){
        body.id = this.id;

        this.mService.post_request('users/update', body)
        .subscribe((resp: any)=>{
          if(resp.status){
            this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
            this.router.navigate([`dashboard/users`]);
          }else{
            if(resp?.errors != undefined){
              resp.errors.forEach(element => {
                this.toast.error( element, resp.message, {timeOut: 5000, progressBar: true, closeButton: true});
              });
            }
          }
        });
      }else{
        this.mService.post_request('users/create', body)
        .subscribe((resp: any)=>{
          if(resp.status){
            this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
            this.router.navigate([`dashboard/users`]);
          }else{
            if(resp?.errors != undefined){
              resp.errors.forEach(element => {
                this.toast.error( element, resp.message, {timeOut: 5000, progressBar: true, closeButton: true});
              });
            }
          }
        });
      }
    }else{
      this.uService.validateForm(this.newUserForm)
    }
  }

  getRoles(){
    this.mService.get_request('rol/list')
    .subscribe((resp: any)=>{
      var rolesResp: any = [];
      if(resp.status){
        Object.keys(resp.items).forEach(key => {
          var roleNameModified: string = '';

          // switch (resp.items[key].role_name) {
          //   case 'superadmin':
          //     roleNameModified = 'Super administrador'
          //   break;
          //   case 'admin':
          //     roleNameModified = 'Administrador'
          //   break;
          //   case 'accounting':
          //     roleNameModified = 'Contabilidad'
          //   break;
          //   case 'trading':
          //     roleNameModified = 'Comercio'
          //   break;
          // }
          rolesResp.push(
            {
              ...resp.items[key],
            }
          )
        });
        this.roles = rolesResp;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  constructor(public uService: UtilsService, private router: Router, private mService: MainService, private toast: ToastrService, private activatedRoute: ActivatedRoute) {
    this.getRoles();

    this.activatedRoute.params.subscribe((params: any)=>{
      if(params.id != undefined){
        this.id = params.id;
        this.mService.get_request('users/list-id/', { id: this.id })
        .subscribe((resp: any)=>{
          if(resp.status){
            this.newUserForm.get('first_name').setValue(resp.items.first_name);
            this.newUserForm.get('last_name').setValue(resp.items.last_name);
            // this.newUserForm.get('username').setValue(resp.items.username);
            this.newUserForm.get('email').setValue(resp.items.email);
            this.newUserForm.get('cellphone').setValue(resp.items.cellphone);
            // this.newUserForm.get('gender').setValue(resp.items.gender);
            // this.newUserForm.get('ci').setValue(resp.items.ci);
            // this.newUserForm.get('status').setValue(resp.items.status);
            if(resp.items.roles.length > 0){
              var roles: any = [];
              resp.items.roles.forEach(role => {
                roles.push(role.id);
              });
              this.newUserForm.get('role').setValue(roles[0]);
            }
          }else{
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
            if(resp.message.includes('expirado')){
              this.uService.logOut$.next(true);
            }
          }
        });
      };
    });
  }

  hidePass(){
    let hideInput = document.getElementById('hide-input');
    let hideRepeat = document.getElementById('hide-input-repeat');
    this.attrHide = !this.attrHide;
    if( this.attrHide){
      hideInput.setAttribute('type', 'text');
      hideRepeat.setAttribute('type', 'text');
    }else{
      hideInput.setAttribute('type', 'password');
      hideRepeat.setAttribute('type', 'password');
    }
  }

  ngOnInit(): void {
  }

}
